import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from '../services/order.service';
import { AuthService } from '../services/auth.service';
import { PageviewsettingsService } from '../services/pageviewsettings.service';
@Component({
  selector: 'app-zip-coverage',
  templateUrl: './zip-coverage.component.html',
  styleUrls: ['./zip-coverage.component.css']
})


export class ZipCoverageComponent {
	tenantId:any;
	affiliateId:any;
	selectedBrand: string = '';
	selectedDevice: string = '';
	imeiNumber: string = '';
	isLoading = false;
	deviceForm: FormGroup;
	coverageForm:FormGroup;
	isCompatible: boolean | null = null;
	private readonly BILLING_CODE = 'ABC123';
	showcoverage: boolean =false;
	isAvailable: boolean |null  =null;
	validZipCodes = ['90210', '10001', '30301', '60601'];
	tenantName:any;
	loadeddata:any;

  constructor(
    private fb: FormBuilder,
    private orderService: OrderService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
      private settingsService: PageviewsettingsService

  ) {
    this.coverageForm = this.fb.group({
     
      zip: ['', [
        Validators.required,
        Validators.pattern(/^\d{5}$/)
      ]],
    
    });
    this.deviceForm = this.fb.group({
     
      imei: ['', [Validators.required, Validators.pattern(/^\d{15}$/)]],
    
    });
    
  }
  
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['planId']) {
        this.coverageForm.patchValue({ planId: params['planId'] });
      }
    });
 this.tenantName = this.route.snapshot.paramMap.get('collegemobile') || '/defaultpage';
    this.settingsService.getCollegetenantcode(this.tenantName).subscribe(data => {
			this.tenantId = parseInt(data.result.id)
			this.affiliateId = data.result.affiliateId
			this.loadPageSettings();
		});


    

   

    this.authService.login().subscribe({
      next: () => {
        console.log('Successfully logged in');
      },
      error: (error) => {
        console.error('Login failed:', error);
      }
    });
  }

  // get iccid() { return this.orderForm.get('iccid'); }
  // get zip() { return this.coverageForm.get('zip'); }
  // get imei() { return this.deviceForm.get('imei'); }

 loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			const color = this.loadeddata?.PrimaryColor;
	
			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
      });
  }  

  checkCoverage() {

    console.log(this.coverageForm.value)
    

    if (this.coverageForm.valid) {
      const zip = this.coverageForm.value.zip;
      
      this.isAvailable = this.validZipCodes.includes(zip);
    }

      

      // this.orderService.submitOrder(orderData).subscribe({
      //   next: (response) => {
      //     this.isLoading = false;
      //     this.router.navigate(['/success']);
      //   },
      //   error: (error) => {
      //     this.isLoading = false;
      //     console.error('Order submission failed:', error);
          
      //   }
      // });
    
    

    
  }

  gotonext(value:any) {
  console.log(value)
  console.log(this.showcoverage)

  if(value == "available"){
    this.showcoverage = true
   

  }
   
  
  if(value == "compatible"){
    this.showcoverage = false
    this.router.navigate(['/order']);

  }
  }

  checkEsimCompatibility() {
    if (this.deviceForm.valid) {
      const imei = this.deviceForm.value.imei;
      
      this.isCompatible = imei.startsWith('35') ? false : true;
    }
  }
// this is for backup 
  checkCompatibility() {
    if (this.imeiNumber || (this.selectedBrand && this.selectedDevice)) {
      alert('Checking device compatibility...');
    } else {
      alert('Please select a device or enter an IMEI number.');
    }
  }

 



}
